const message = {
    toptips: "Tamperproof, Traceable, Open",
    traning_code: "Tracing code",
    scantimes: 'Scan times',
    productinfo: 'Product info',
    batch_no: 'Batch No.',
    product_name: 'Product name',
    blockchain_ident: 'Txhash',
    not_support_video: 'Your browser kernel does not support video tags',
    blockchain_verify: 'Blockchain verify',
    pass: 'PASS',
    blockchian: "Blockchain",
    hxchain: 'HXChain',
    height: 'height',
    evidence_time: 'Evidence time',
    signature: 'Digital signature',
    txhash: 'Txhash',
    pass_content: 'Has been encrypted and stored in the blockchain,  not been tampered with！',
    inputCheckCode: 'Input the 6-digit verification code',
    input_code: 'Please input the 6-digit code',
    query: "Query",
    queryTitle: "Tracing Query",
    errCheckCode: "Sorry, the verification code you entered is invalid. Please verify and re-enter it",
    tooManyQuery: "Too many query errors. Please try again later",
    tips2: "One thing, one code, blockchain traceability, global quality assurance!",
    goodsInfo: "Goods Info",

    warranty_application: 'Warranty',
    product_info: 'Product Info',
    warranty_status: 'Warranty Status',
    warranty_valid: 'In Warranty',
    warranty_expired: 'Expired',
    application_info: 'Application',
    applicant_name: 'Name',
    please_input_name: 'Enter name',
    name_required: 'Name required',
    contact_info: 'Contact',
    please_input_contact: 'Enter contact',
    contact_required: 'Contact required',
    feedback_content: 'Description',
    please_input_feedback: 'Describe issue',
    feedback_required: 'Description required',
    submit_application: 'Submit',
    application_submitted_success: 'Submitted',
    processing_progress: 'Progress',
    application_submitted: 'Submitted',
    application_submitted_desc: 'Application submitted',
    under_review: 'In Review',
    under_review_desc: 'Being reviewed',
    start_time: 'Start Date',
    history_records: 'History',
    no_history_records: 'No records',
    processing_result: 'Result',
    reason: 'Reason',
    status_submitted: 'Submitted',
    status_processing: 'Processing',
    status_processed: 'Processed',
    status_unknown: 'Unknown',
    load_history_failed: 'Failed to load',
    warranty_tips: 'Pending application exists',
    feed_ask: 'Expected Result',
    status_failed: 'Failed',
}


module.exports = message